module.exports = __webpack_public_path__ + "static/img/hw.74a07ced.png";